import * as React from "react"

import { cn } from "../../cn"

export interface TableControlsRowProps {
  children?: React.ReactNode
  className?: string
}

/**
 * The controls that belong to a full-page table — search, filters, column
 * toggles — sitting in their own row directly above it rather than up in the
 * page header. The horizontal padding matches the table's edge gutter so the
 * controls line up with the first column.
 *
 * The row is a `@container`, so a control that collapses on the space it has —
 * `CollapsibleSearchInput` on its default container query — measures against
 * this row rather than needing a container of its own.
 */
export const TableControlsRow = ({
  children,
  className,
}: TableControlsRowProps) => (
  <div
    className={cn(
      // The bottom border closes the row off against the table's own header
      // row directly beneath it.
      "@container flex flex-none items-center gap-2 border-b border-coval-border px-6 py-3",
      className,
    )}
  >
    {children}
  </div>
)
